import { render, staticRenderFns } from "./AdvancedRevisionIndex.vue?vue&type=template&id=c14028d8&"
import script from "./AdvancedRevisionIndex.vue?vue&type=script&lang=js&"
export * from "./AdvancedRevisionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports